import { Button, Form, Input, Layout, TableColumnsType, Tag } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons/lib";
import React, { useCallback, useMemo, useState } from "react";
import CommonTableComponent from "../common-table-component";
import resources from "../../../resources";
import server from "../../../server";

const columns: TableColumnsType = [
    {
        title: "Display Name",
        dataIndex: 'displayName',
        align: "left",
    },
    {
        title: 'Description',
        dataIndex: 'description',
        align: "left",
    },
    {
        title: 'Status',
        dataIndex: 'active',
        align: "left",
        render: (active: boolean) => (
            <Tag className={`status-pill ${active ? "active" : "inactive"}`}>
                {active ? "Active" : "Inactive"}
            </Tag>
        ),
    },
]

const Qualification = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tempResources = resources.commonButtonText;
    const qualificationColumn = columns;
    const fetchQualifications = useCallback(async (params?: any) => {
        try {
            const qualifications = params
                ? await server.settings.qualification.list(params)
                : await server.settings.qualification.list();
            const newQualifications = qualifications.map((designation: any) => ({
                ...designation,
            }))
            return newQualifications;
        } catch (e) {
            return [];
        }
    }, []);

    const propsData = useMemo(
        () => ({
            title: "Qualification",
            create: server.settings.qualification.create,
            getAll: fetchQualifications,
            delete: server.settings.qualification.delete,
            update: server.settings.qualification.updateStatus,
            updateQualification: server.settings.qualification.update,
            isModalOpen: isModalOpen,
            setIsModalOpen: setIsModalOpen,
            columns: qualificationColumn,
            deleteById: server.settings.qualification.delete,
            formFields: [
                <Form.Item
                    label="Code"
                    name={"code"}
                    rules={[{required: true, message: 'Please input Code!'}]}>
                    <Input placeholder={'Enter code'} name={"code"}/>
                </Form.Item>,
                <Form.Item
                    label="Description"
                    name="description"
                    rules={[{required: true, message: 'Please input Description!'}]}>
                    <Input placeholder={'Enter description'} name="description"/>
                </Form.Item>,
                <Form.Item
                    label="Display Name"
                    name="displayName"
                    rules={[{required: true, message: 'Please input Display Name!'}]}>
                    <Input placeholder={'Enter display name'} name="displayName"/>
                </Form.Item>,
            ],
            formFieldsType: [
                {name: "code", type: "code"},
                {name: "description", type: "string"},
                {name: "displayName", type: "string"},
            ],
            tableFieldsType: [
                {name: "code", type: "code"},
                {name: "description", type: "string"},
                {name: "status", type: "boolean"}
            ],
            showStatus: true,
            updateRecord: true
        }),
        [isModalOpen, setIsModalOpen, qualificationColumn, fetchQualifications]
    );

    return (

        <div className="settings-section">
            <div className={'settings-section__heading'}>
                <h4>Qualification</h4>
                <Button type="primary"
                        icon={<PlusCircleOutlined/>}
                        onClick={() => setIsModalOpen(true)}
                        className="settings-section__action-button">
                    {tempResources.addButton}
                </Button>
            </div>
            <Layout className="settings-section__table-layout">
                <CommonTableComponent propsData={propsData}/>
            </Layout>
        </div>
    )
}

export default Qualification;
